export const headerAppBarHeight = 66;
export const orderAppBarHeight = 85;
export const drawerWidth = 390;
export const sidebarWidth = 300;
export const sidebarCollapsedWidth = 96;
export const widgetHeight = 255;
